import { IStudentDashboard } from "../../../models/dashboard/studentDashboard";
import { useEffect } from "react";
import { connect } from "react-redux";
import StudentApps from "./components/studentApps";
import StudentCourseDetails from "./components/studentCourseDetails";
import AcademicProfile from "./components/academicProfile";
import NextTerm from "./components/nextTerm";
import StudentGradeDetails from "./components/studentGradeDetails";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import StudentResourcesWidgets from "./components/studentResourcesWidgets";
import StudentAccount from "./components/StudentAccount";
import MonthCalendar from "../../../common-components/calendar/monthCalendar";
import Freshman from "./components/freshman";
import { greetings } from "../../../common-functions/commonFunctions";
import { getFreshmanProcessVersion } from "../../../action/freshman/freshmanProcessActionCreator";

const StudentDashboard = (props: IStudentDashboard) => {
  const { userInfo, getSnapShots, getFreshmanVersion, freshmanProcessVersion } = props;

  useEffect(() => {
    getSnapShots();
  }, []);

  useEffect(() => {
    userInfo && getFreshmanVersion();
  }, [userInfo])

  const shouldRenderFreshman = userInfo?.isFreshman;
  const shouldRenderDashboard =
    !userInfo?.isFreshman || userInfo?.isCourseStarted;

  return (
    <>
      <div className="row mb-3">
        <div className="dash-title col-lg-6">
          <h2 className="mb-2">{greetings()}, {userInfo?.displayName}</h2>
          <p>
            {shouldRenderDashboard
              ? "Welcome! Access your Dashboard to review your Widgets and Apps, and navigate to other resources with ease. Access the sidebar menu to view all your academic and campus resources."
              : "Welcome! Click the setup button to begin your registration process. Navigate through the sidebar for everything you need."}
          </p>
        </div>
      </div>

      {shouldRenderFreshman && (
        <div className="row mb-3">
          <div className="col-lg-12 mb-3">
            <Freshman userInfo={userInfo} />
          </div>
        </div>
      )}

      {shouldRenderDashboard && (
        <div className="row studdash-mobile">
          <div className="col-lg-8 mb-3">
            <div className="card-wrap">
              <div className="widgets">
                <div className="title">
                  <h2>Student Metrics</h2>
                </div>
                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <AcademicProfile />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <StudentCourseDetails />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <StudentAccount />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <StudentGradeDetails />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-3">
            <StudentApps />
          </div>
          <div className="col-lg-4">
            <StudentResourcesWidgets />
          </div>
          <div className="col-lg-4">
            <NextTerm />
          </div>
          <div className="col-lg-4">
            <MonthCalendar />
          </div>
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
  getFreshmanVersion: () => getFreshmanProcessVersion()
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
    freshmanProcessVersion: state.freshmanProcess.freshmanProcessVersion
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentDashboard)
